<template>
  <div class="form__element radio-list radio-list--inline">
    <v-radio
      v-for="(option, key) in options"
      :name="name"
      :required="name && required"
      :label="option.label"
      :value="option.value"
      :key="'radio_' + key + '_opt'"
    />
    <slot></slot>
  </div>
</template>
<script>
import { formMixin } from "../../../mixins";
export default {
  mixins: [formMixin],

  model: {
    prop: "checked",
    event: "input"
  },

  props: {
    options: {
      type: Array,
      default: function() {
        return [];
      }
    },
    checked: {
      type: [String, Object, Number, Boolean],
      default: null
    }
  },

  data() {
    return {
      localChecked: this.checked,
      is_RadioCheckGroup: true
    };
  },

  watch: {
    checked(newVal, oldVal) {
      this.localChecked = this.checked;
    },

    localChecked(newVal, oldVal) {
      this.$emit("input", newVal);
    }
  },

  computed: {
    get_State() {
      // Required by child radios
      return this.computedState;
    }
  }
};
</script>
